import React, { useState, useCallback, useEffect } from 'react'
import { Alert, FormGroup, Label, Input, Button } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'connected-react-router'
import { fetchContractLineAssets } from 'store/contractLineAssetManager/operations'
import { NetSuiteAsset, RootState } from 'types'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'

interface ContractLineSearchProps {
  // Add any additional props if needed
}

const ContractLineSearch: React.FC<ContractLineSearchProps> = () => {
  const [contractLineNSId, setContractLineNSId] = useState<number>(0)
  const [notFound, setNotFound] = useState<boolean>(false)

  const dispatch = useDispatch()
  const { isLoading, netSuiteAssets, error } = useSelector(
    (state: RootState) => state.contractLineAssetManager,
  )

  useEffect(() => {
    if (netSuiteAssets && Object.keys(netSuiteAssets).length > 0) {
      const firstAsset = Object.values(netSuiteAssets)[0] as NetSuiteAsset
      dispatch(push(`/css-admin/contractLine/${firstAsset.contractLineNSId}`))
    }
  }, [netSuiteAssets])

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    if (name === 'contractLineNSId') {
      setContractLineNSId(parseInt(value, 10))
    }
  }, [])

  const handleKeydown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        handleSearch()
      }
    },
    [contractLineNSId],
  )

  const handleSearch = useCallback(() => {
    if (!contractLineNSId) {
      setNotFound(true)
      return
    }

    setNotFound(false)
    dispatch(fetchContractLineAssets(contractLineNSId))
  }, [contractLineNSId, dispatch])

  return (
    <React.Fragment>
      <h2>Contract Line Search</h2>
      <hr />
      <ErrorBoundary>
        <Loading isLoading={isLoading} />
        <FormGroup>
          <Label htmlFor="contractLineNSId">Contract Line ID</Label>
          <Input
            id="contractLineNSId"
            name="contractLineNSId"
            onChange={handleChange}
            onKeyDown={handleKeydown}
            type="number"
            value={contractLineNSId || ''}
            placeholder="Enter Contract Line ID"
          />
        </FormGroup>
        <hr />
        <div className="text-right">
          <Button
            className="btn-fixed-width"
            color="primary"
            onClick={handleSearch}
            disabled={!contractLineNSId}
          >
            <i className="fas fa-search" />
            &nbsp;Search
          </Button>
        </div>
        {(notFound || error) && (
          <Alert color="warning">{error || 'Not found'}</Alert>
        )}
      </ErrorBoundary>
    </React.Fragment>
  )
}

export default ContractLineSearch
